// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cidx-pager__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.cidx-table.is-fetching {
  opacity: 0.72;
}

.cidx-table--relaxed .cidx-table__row .cidx-cell {
  min-height: 56px;
  padding: 14px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/library/components/DataTable/style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".cidx-pager__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cidx-table.is-fetching {\n  opacity: 0.72;\n}\n\n.cidx-table--relaxed .cidx-table__row .cidx-cell {\n  min-height: 56px;\n  padding: 14px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
